import type { PrimeVuePTOptions } from 'primevue/config';

export default {
  root({ state, props }) {
    return {
      class: [
        'rounded-[6px]  h-control bg-[--v3-input-field-inputbg]',
        { 'opacity-50': props.disabled },
        {
          'border-[--v3-input-field-inputborder]': !state.focused,
          'border-[--v3-input-field-inputfocusbordercolor] shadow-[0px_0px_0px_2.8px_var(--brand-forestgreenwarm)] outline-none': state.focused,
        },
      ],
    };
  },
  header: {
    class: 'pt-0 px-0',
  },
  filterInput: {
    class: 'rounded-b-none border-t-0 border-x-0',
  },
  list: {
    class: ['pt-[10.5px] pb-0 px-0'],
  },
  trigger: {
    class: ['text-[--v3-input-field-inputiconcolor]'],
  },
  input: {
    class: ['flex items-center v3-body-regular-400-line-height-auto text-[--v3-global-textsecondarycolor]'],
  },
  item({ context }) {
    return {
      class: [
        `h-control rounded-none v3-body-regular-400-line-height-auto m-0 px-[17.5px] py-[10.5px]
        text-[--v3-global-textcolor] hover:bg-[--v3-theme-highlightbg]
        hover:text-[--v3-theme-highlighttextcolor]`,
        {
          'bg-[--v3-theme-highlightbg] text-[--v3-theme-highlighttextcolor]': context.selected || context.focused,
        },
      ],
    };
  },
} satisfies PrimeVuePTOptions['dropdown'];
